module.exports = __webpack_public_path__ + "static/media/backgroundTruckField.5e84497b.svg";